export enum PanelHeadingShadowEnum {
  TOP = "top",
  BOTTOM = "bottom",
}

export enum PanelHeadingTonesEnum {
  // The app's document heading: Orbitron via Heading's `hero`, at text-2xl.
  DEFAULT = "default",
  // The metrics-card label: small, tracked, uppercase, with a gold status dot.
  // Suits short fixed labels, not free-form names.
  METRIC = "metric",
}
